/**
 * Potential blast distances for the API in KM.
 *
 * @type {number[]}
 */
export const ADMIN_BLASTER__DISTANCES_AVAILABLE = [
  50,
  200,
  500,
  1000
];

/**
 * @type {Object}     Sort names for the different sorted columns
 */
export const ADMIN_BLASTER__SORT_NAMES = {
  APPLIED: 'hasApplied',
  EMAIL: 'userEmail',
  DAYS_SINCE_SEEN: 'userDaysSinceSeen',
  HOME_DISTANCE: 'homeDistance',
  LAST_LOCATION: 'userLastLocation',
  LOCATION: 'userLocation',
  NAME: 'userName',
  NOTIFIED: 'userNotifiedCount',
  RATING: 'userRating',
};

/**
 * @type {number}   The maximum min rating star filter that the admin can select.  Starts at 0
 */
export const ADMIN_BLASTER__STAR_FILTER_COUNT = 5;
